import { Component, OnInit, Inject } from '@angular/core';

@Component({
    selector: 'app-emergency-notes',
    templateUrl: './notes.component.html',
    styleUrls: ['./notes.component.scss']
})
export class EmergencyNotesComponent {

    constructor() { }

    ngOnInit() {
    }

}

